import { Component } from '@theme/component';

/**
 * `<collapsible-panel>` — a section-level mobile accordion. The element carries
 * `data-expanded`; a `<button aria-expanded on:click="/togglePanel">` inside it
 * flips the state. Which children hide when collapsed, and at which breakpoint
 * the panel stops collapsing, is owned by the consumer's CSS
 * (`[data-expanded='false'] .foo { display: none }` on mobile, reverted at ≥750px).
 *
 * Same contract as the inline component in `sections/test-ablauf.liquid` and
 * `togglePanel` in `assets/test-funktioniert.js`; new sections should use this
 * element instead of copying that code.
 *
 * @extends {Component}
 */
class CollapsiblePanel extends Component {
  /** `on:click` sits on the toggle button, so event.target is the button itself. */
  togglePanel = (event) => {
    const button = event.target instanceof HTMLButtonElement ? event.target : null;
    const next = this.dataset.expanded === 'false';
    this.dataset.expanded = String(next);
    if (button) button.setAttribute('aria-expanded', String(next));
  };
}

if (!customElements.get('collapsible-panel')) {
  customElements.define('collapsible-panel', CollapsiblePanel);
}
